import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrderDownloadMenuComponent } from './work-order-download-menu.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

/**
 * Module per il componente WorkOrderDownloadMenu
 * 
 * Questo modulo esporta il componente che gestisce il menu di download
 * per i WorkOrder, mostrando sia il PDF generato che i file caricati
 */
@NgModule({
  declarations: [
    WorkOrderDownloadMenuComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule
  ],
  exports: [
    WorkOrderDownloadMenuComponent
  ]
})
export class WorkOrderDownloadMenuModule { }
